import { graphql } from '../gql'

/**
 * Public resolver (shield: allow); non-admin sessions only get active links.
 * `authorization.token` is the operator-scoped token the short link carries
 * (from the SMS): the mini-app runs on it so a logged-out operator can open
 * their assignment without signing in, exactly like v1.
 */
export const GetShortLink = graphql(`
	query GetShortLink($slug: String!) {
		shortLink(where: { slug: $slug }) {
			slug
			sub
			redirect
			expires
			authorization {
				token
			}
		}
	}
`)
